import { DataModel } from "common/models/utility-models/base-model";

export class PrivacyModel extends DataModel {
    termsAndDisclaimer:string = '';
}